import {
    _forEach,
} from '@samclick-lodash';
import { toMoney } from '@/utils/common-utils';

const CasinoColor = new Map([
    [1, 'rgb(255, 99, 132)'],
    [2, 'rgb(255, 205, 86)'],
]);

export class PieConfig {
    legendKey: string = '' // key of legend in list

    key: string = '' // key of data

    colorMapper: string | number = ''

    isMoney: boolean = false

    constructor(legendKey: string = '', key: string = '', colorMapper: string | number = '', isMoney: boolean = false) {
        this.legendKey = legendKey;
        this.key = key;
        this.colorMapper = colorMapper;
        this.isMoney = isMoney;
    }
}

function buildDataSets(config: PieConfig, data: object[]) {
    const labels: string[] = [];
    const values: number[] = [];
    const colors: string[] = [];
    _forEach(data, (v) => {
        labels.push(v[config.legendKey]);
        values.push(config.isMoney ? toMoney(v[config.key], 2, false) : v[config.key]);
        colors.push(CasinoColor.get(v[config.colorMapper]));
    });

    return {
        labels,
        datasets: [
            {
                data: values,
                backgroundColor: colors,
            },
        ],
    };
}

export function generatePie(config: PieConfig, data: object[] = [], parentProps: object) {
    return {
        chartData: buildDataSets(config, data),
        chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: true,
                text: parentProps.title,
            },
            tooltips: {
                mode: 'index',
                intersect: false,
                callbacks: {
                    label(tooltipItem, data) {
                        let tooltipValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        const tootTiplabel = data.labels[tooltipItem.index] || '';

                        if (tooltipValue.toString().indexOf('.') !== -1) {
                            tooltipValue = toMoney(tooltipValue);
                        } else {
                            tooltipValue = tooltipValue.toString();
                        }

                        return `${tootTiplabel} : ${tooltipValue}`;
                    },
                },
            },
        },
    };
}
